// components/features/support/clients/CreateClientModal.tsx
import { useState } from "react";
import BaseModal from "../../ui/Modal";
import ClientForm, { ClientFormData } from "./ClientForm";

interface CreateClientModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess: (clientData: ClientFormData) => void;
}

export default function CreateClientModal({
  isOpen,
  onClose,
  onSuccess,
}: CreateClientModalProps) {
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (formData: ClientFormData) => {
    setLoading(true);
    try {
      await onSuccess(formData);
      onClose();
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <BaseModal isOpen={isOpen} onClose={onClose} title="Nouveau client">
      <ClientForm
        onSubmit={handleSubmit}
        onCancel={handleCancel}
        loading={loading}
        submitLabel="Créer le client"
        cancelLabel="Annuler"
      />
    </BaseModal>
  );
}